const LoadingTableSpinner = (props) => (
  <div className="loading-data">
    <div className="spinner-wrap"><div className="css-spinloader"></div></div>
    <span>{props.text || 'Laden...'}</span>
  </div>
);

export default LoadingTableSpinner;
